import type { FetchResult } from '@apollo/client/core'
import { ApolloError } from '@apollo/client/core'
import type { GraphQLError, GraphQLFormattedError } from 'graphql'
import type { IErrorCode } from 'src/graphql'

export const containsGqlErrorCode = (error: ApolloError | FetchResult, code: IErrorCode) => {
  const errors: Array<GraphQLError | GraphQLFormattedError> = []
  if (error instanceof ApolloError) {
    errors.push(...error.graphQLErrors)
  } else if (error.errors) {
    errors.push(...error.errors)
  }
  if (errors.length) console.debug({ code, errors })

  return errors.find((err) => err.extensions?.code === code) !== undefined
}
